import { Button, ListGroup } from "react-bootstrap";
import { parseDeviceModel } from "./utils";

/**
 * Individual passkey item component for displaying passkey information
 * @param {Object} props - Component props
 * @param {Object} props.passkey - Passkey object containing id, name, model, created, lastUsed
 * @param {Function} props.onDelete - Callback function when delete button is clicked
 * @param {boolean} [props.isLoading=false] - Whether component is in loading state
 * @returns {JSX.Element} Rendered passkey item
 */
const PasskeyItem = ({ passkey, onDelete, isLoading = false }) => {

  const deviceDetails = parseDeviceModel(passkey.model);

  return (
    <ListGroup.Item
      className="passkey-item border-bottom border"
      style={{ borderColor: "#e9ecef", borderWidth: "1px" }}
    >
      {/* Main Row - always visible */}
      <div className="d-flex align-items-start p-2">
        {/* Two rows, two columns content area */}
        <div className="flex-grow-1">
          <strong>Passkey ({passkey.passkeyType})</strong>
          <p className="mb-2 mt-1">
            {deviceDetails.authenticatorDevice?.includes("Unknown") ? '' : deviceDetails.authenticatorDevice + ' - '}{deviceDetails.method} device
          </p>
          <small>
            Date registered {passkey.created
              ? new Date(passkey.created + "Z").toLocaleString("en-AU", { month: "long", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" })
              : "Unknown"}
          </small>
        </div>

        {/* Buttons: Delete first, then Dropdown */}
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="link"
            size="sm"
            onClick={(e) => {
              e.stopPropagation(); // Prevent expanding when clicking delete
              onDelete(passkey);
            }}
            disabled={isLoading}
          >
            <b>Delete</b>
          </Button>
        </div>
      </div>
    </ListGroup.Item>
  );
};

export default PasskeyItem;
